<template>
  <div class="container-fluid">
    <div class="container-showcase justify-start">
      <div>
        <div class="mt-5">
          <Selfie />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Selfie from "./components/MediaPipe/Selfie.vue";

export default {
  name: "DemoveRemBkgr",
  components: { Selfie },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style scoped>
#output_canvas {
  /*background-image: url("https://wallpapercave.com/wp/wp4676582.jpg");*/
  background-repeat: no-repeat;
  background-size: cover;
  /*margin-bottom: 10px;*/
}
</style>
